module.exports = __webpack_public_path__ + "files/ac951b6fe961b87b5e85c2e3394d410c.png";